import React from 'react';
import ReactiveContainer from '../../common/ReactiveContainer';
import classNames from 'classnames';

interface CommentsSidePanelContentProps {
  className?: string;
  recordType: string;
  recordId: string;
  sidebarId: string;
  baseUrl?: string;
  isShared?: boolean;
}

const CommentsSidePanelContent: React.FC<CommentsSidePanelContentProps> = ({
  className,
  recordType,
  recordId,
  sidebarId,
  isShared,
  baseUrl,
}) => {
  return (
    <ReactiveContainer
      reactivePath={`${recordType}-${recordId}/Annotation`}
      reactiveUrl={`${
        baseUrl ?? ''
      }/annotations?annotatable_id=${recordId}&annotatable_type=${recordType}`}
      isShared={isShared}
      className={classNames(className, 'js-annotations-sidebar')}
      data-annotations-sidebar-id={`sidebar-${sidebarId}`}
      data-reactive-preserve-attributes='true'
      style={{ '--aha-editor-v2--body-min-height': 'initial' }}
    />
  );
};

export default CommentsSidePanelContent;
